import { httpClient } from '@configs/httpclient.config';
import { AxiosResponse } from 'axios';
import { FeedbackReq, FeedbackResult } from '@libs/components/pageBlocks/Feedback/services/feedback.type';
import { ResponseInfo } from '@libs/types';

export const FEEDBACK_URL = '/moex-datashop-reference-service/api/enquiries/v1';

export const sendFeedback = (body: FeedbackReq): Promise<AxiosResponse<ResponseInfo<FeedbackResult>>> =>
    httpClient.post(FEEDBACK_URL, body);
